// Periods the dashboard endpoints accept as filterByLast
export const WINDOW_OPTIONS = [
  { id: "24-hour", value: "24 hours", label: "last 24 hours" },
  { id: "7-day", value: "7 days", label: "last 7 days" },
  { id: "30-day", value: "30 days", label: "last 30 days" },
  { id: "90-day", value: "90 days", label: "last 90 days" },
];

// The option CustomSelect saved under `${id}LastSelected`, so the first
// request already uses it instead of the default
export const storedWindow = (selectId, fallback) => {
  try {
    const stored = JSON.parse(localStorage.getItem(`${selectId}LastSelected`));
    return WINDOW_OPTIONS.find((option) => option.id === stored?.id) || fallback;
  } catch (e) {
    return fallback;
  }
};

export const formatDate = (value) => {
  if (!value) return "-";
  const date = new Date(value);
  if (isNaN(date)) return value;
  return date.toLocaleString(undefined, {
    year: "numeric",
    month: "short",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  });
};

// Timeline keys are "YYYY-MM-DD" days or "YYYY-MM-DDTHH:00" hours, already in
// the viewer's time zone
export const bucketLabel = (key, unit) => {
  if (unit === "hour") return key.slice(11, 16);
  const [year, month, day] = key.split("-").map(Number);
  return new Date(year, month - 1, day).toLocaleDateString(undefined, {
    month: "short",
    day: "numeric",
  });
};
